export interface SessionActivityTarget {
  visibilityState?: string;
  addEventListener(type: string, listener: () => void): void;
  removeEventListener(type: string, listener: () => void): void;
}

interface SessionActivityHeartbeatOptions {
  target: SessionActivityTarget;
  send: () => void;
  now?: () => number;
  throttleMs?: number;
}

const MEANINGFUL_ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart'];

export function installSessionActivityHeartbeat({
  target,
  send,
  now = () => Date.now(),
  throttleMs = 300_000,
}: SessionActivityHeartbeatOptions): () => void {
  let lastSentAt = Number.NEGATIVE_INFINITY;
  const onActivity = () => {
    const currentTime = now();
    if (currentTime - lastSentAt < throttleMs) return;
    lastSentAt = currentTime;
    send();
  };
  for (const event of MEANINGFUL_ACTIVITY_EVENTS) {
    target.addEventListener(event, onActivity);
  }
  const onVisibilityChange = () => {
    if (target.visibilityState === 'visible') onActivity();
  };
  target.addEventListener('visibilitychange', onVisibilityChange);
  onActivity();
  return () => {
    for (const event of MEANINGFUL_ACTIVITY_EVENTS) {
      target.removeEventListener(event, onActivity);
    }
    target.removeEventListener('visibilitychange', onVisibilityChange);
  };
}
